'use client';

import { useEffect } from 'react';
import { AUTH_CHANGED_EVENT, hasStoredAuthToken } from '../services/auth-storage';
import { linkAcquisitionVisits } from '../services/home-acquisition';

export default function HomeAcquisitionIdentity() {
  useEffect(() => {
    const link = () => { if (hasStoredAuthToken()) void linkAcquisitionVisits(); };
    const authChanged = () => {
      if (hasStoredAuthToken()) link();
    };
    window.addEventListener(AUTH_CHANGED_EVENT, authChanged);
    window.addEventListener('pte-acquisition-ready', link);
    window.addEventListener('online', link);
    window.addEventListener('pageshow', link);
    window.addEventListener('focus', link);
    const retry = window.setInterval(link, 30000);
    link();
    return () => {
      window.removeEventListener(AUTH_CHANGED_EVENT, authChanged);
      window.removeEventListener('pte-acquisition-ready', link);
      window.removeEventListener('online', link);
      window.removeEventListener('pageshow', link);
      window.removeEventListener('focus', link);
      window.clearInterval(retry);
    };
  }, []);
  return null;
}
